export const SourceMelCategory = "melcategorys";

export const TitleMelCategory = { list: "Mel Category List", edit: "Edit Mel Category", create: "Create Mel Category" };
